import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Firebase configuration — values come from environment variables so the same
// build can target different Firebase projects.
// Get values from: Firebase Console → Project Settings → General → Your apps → Web app.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY;
const appCheckDebugToken = process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN;

if (!firebaseConfig.projectId) {
  // Fail loudly during development — a missing config is the #1 cause of
  // confusing "permission denied" errors from Storage/Functions.
  // eslint-disable-next-line no-console
  console.error(
    "Firebase config is incomplete. Make sure REACT_APP_FIREBASE_* env vars are set."
  );
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

if (appCheckSiteKey) {
  if (
    appCheckDebugToken &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1")
  ) {
    (globalThis as typeof globalThis & {
      FIREBASE_APPCHECK_DEBUG_TOKEN?: string | boolean;
    }).FIREBASE_APPCHECK_DEBUG_TOKEN =
      appCheckDebugToken === "true" ? true : appCheckDebugToken;
  }

  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  // eslint-disable-next-line no-console
  console.warn(
    "REACT_APP_FIREBASE_APPCHECK_SITE_KEY is missing; App Check is disabled in this build."
  );
}

// Initialize Firebase Storage
const storage = getStorage(app);

// Initialize Firebase Functions (region must match deployed function)
const functions = getFunctions(app, "us-east1");

export { storage, functions };
export default app;
